import { ProviderBranding, ProviderCustomizeService } from 'src/app/services/provider-customize.service';
import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],
  standalone: false
})
export class ToolbarComponent implements OnDestroy {
  apiUrl: string;
  branding$: Observable<ProviderBranding>;
  private subscriptions = new Subscription();

  constructor(
    private sharedDataService: SharedDataService,
    private providerCustomizeService: ProviderCustomizeService,
  ) {
    this.apiUrl = this.sharedDataService.apiUrl;
    this.branding$ = this.providerCustomizeService.branding$;

    this.subscriptions.add(
      this.sharedDataService.apiUrl$.subscribe((data) => {
        this.apiUrl = data;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
